export class ValidationRulesProvider {
  constructor(ValidationRules) {
    'ngInject';

    // Contains validation rules
    this.rules = angular.copy(ValidationRules);
  }

  /**
   *  Adds a validation rule by its key.
   *  A rule is defined as regex or function.
   */
  addRule(key, rule) {
    this.rules[key] = rule;
  }

  getRules() {
    return this.rules;
  }

  $get() {
    'ngInject';
    const { rules, addRule, getRules } = this;

    return { rules, addRule, getRules };
  }
}
